<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページで提供しているコンテンツはCDNを経由して提供できています。
        </p>
        <p v-else>
          あなたのWebページの提供しているコンテンツコンテンツはCDNを経由しての提供はできていません。
        </p>
      </div>
    </li>
    <li
      v-if="contentCdnUsedLinks.length || contentCdnUnusedLinks.length"
      class="c-list--checkup__item"
    >
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <dl v-if="contentCdnUsedLinks.length">
          <dt>CDNを経由しているリンク</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in contentCdnUsedLinks" :key="index">
                {{ item.url }}
              </li>
            </ul>
          </dd>
        </dl>
        <dl v-if="contentCdnUnusedLinks.length">
          <dt>CDNを経由していないリンク</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in contentCdnUnusedLinks" :key="index">
                {{ item.url }}
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          コンテンツはCDNを経由して提供してください。<br />CDNに関しての詳細は、<a
            href="https://service.plan-b.co.jp/blog/seo/16239/"
            target="_blank"
            >こちら</a
          >を確認ください。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    contentCdnUsedLinks() {
      if (this.detail.link.used) {
        return this.detail.link.used.filter(item => item.url);
      }
      return [];
    },
    contentCdnUnusedLinks() {
      if (this.detail.link.unused) {
        return this.detail.link.unused.filter(item => item.url);
      }
      return [];
    }
  }
};
</script>
